import { render } from "./Report.vue?vue&type=template&id=b5d5d706"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/efakturastat.dev.oneit.rs/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/views/Report.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5d5d706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5d5d706', __exports__)) {
    console.log('reload')
    api.reload('b5d5d706', __exports__)
  }
  
  module.hot.accept("./Report.vue?vue&type=template&id=b5d5d706", () => {
    console.log('re-render')
    api.rerender('b5d5d706', render)
  })

}


export default __exports__